import { memo } from 'react';
import HeaderTitle from 'src/view/containers/Headers/components/HeaderTitle/HeaderTitle';
import Headers from 'src/view/containers/Headers/Headers';

const CallCenterHeader: React.FC = (): JSX.Element => {
  return (
    <div className="d-flex flex-column full-width">
      <Headers>
        <div className="d-flex flex-row align-items-center justify-content-between">
          <HeaderTitle title="call_center" />
        </div>
      </Headers>
    </div>
  );
};

export default memo(CallCenterHeader);
